import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=e89b2bf2&scoped=true"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplate.vue?vue&type=style&index=0&id=e89b2bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89b2bf2",
  null
  
)

export default component.exports